import { isEmpty } from "lodash-es";
import { Button, DeleteIcon, Space } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { useConfirm } from "melco-shared-logic";
import { useDeleteMachineGroups } from "../../../hooks/reporting/useDeleteGroups";

type BulkActionDeleteMachineGroupsProps<T> = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
  refetch?: () => Promise<any>;
  data?: T[];
};

export const BulkActionDeleteMachineGroups: React.FC<
  BulkActionDeleteMachineGroupsProps<any>
> = ({ selectedRowKeys, setSelectedRowKeys, refetch, data }) => {
  const { t } = useTranslation();

  const deleteMachineGroups = useDeleteMachineGroups();
  //const showWarningForRowKeys = useShowWarningForRowKeys(selectedRowKeys, data);

  const confirmDelete = useConfirm(
    async () => {
      const successfullyDeletedIds = await deleteMachineGroups(
        selectedRowKeys.map((key) => key.toString())
      );

      if (refetch) {
        refetch();
      }

      // keep items that were not deleted selected
      setSelectedRowKeys(
        selectedRowKeys.filter(
          (id) => !successfullyDeletedIds.includes(id.toString())
        )
      );
    },
    {
      translationPrefix: "reporting.machinegroups.actions.delete",
      translationOptions: {
        count: selectedRowKeys.length,
      },
      content: (
        <Space direction="vertical" size="small">
          {t(
            "reporting.machinegroups.actions.delete.confirmation.message_other"
          )}
          {/* <Alert
            type="warning"
            withBackground
            description={t("machineGroups.actions.delete.confirmation.warning", {
              count: showWarningForRowKeys.length,
            })}
            showIcon={false}
          /> */}
        </Space>
      ),
    }
  );

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-machine-groups-delete"
      icon={<DeleteIcon />}
      onClick={() => {
        confirmDelete();
      }}
    >
      {t("reporting.machinegroups.actions.delete.delete_selected")}
    </Button>
  );
};
